import { useEffect, useRef } from "react";

// JS (requestAnimationFrame) marquee — guaranteed to move regardless of
// CSS prefers-reduced-motion overrides or browser animation quirks.
export default function BrandMarquee({ speed = 60 }) {
    const trackRef = useRef(null);
    const offsetRef = useRef(0);
    const rafRef = useRef(0);
    const lastRef = useRef(0);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const step = (ts) => {
            if (!lastRef.current) lastRef.current = ts;
            const dt = (ts - lastRef.current) / 1000;
            lastRef.current = ts;
            // width of one half (track contains the sequence twice)
            const half = track.scrollWidth / 2 || 1;
            offsetRef.current = (offsetRef.current + speed * dt) % half;
            track.style.transform = `translate3d(${-offsetRef.current}px,0,0)`;
            rafRef.current = requestAnimationFrame(step);
        };
        rafRef.current = requestAnimationFrame(step);
        return () => cancelAnimationFrame(rafRef.current);
    }, [speed]);

    const Segment = () => (
        <span className="mx-8 font-display text-4xl font-semibold text-stroke sm:text-5xl">
            YOUR MOVE. OUR CARE. <span className="mx-4 text-brand-red">•</span> PROCARE.SG{" "}
            <span className="mx-4 text-brand-red">•</span>
        </span>
    );

    return (
        <div className="overflow-hidden bg-brand-surface py-6">
            <div className="w-full overflow-hidden">
                <div ref={trackRef} className="flex w-max flex-nowrap whitespace-nowrap will-change-transform">
                    {[...Array(2)].map((_, half) => (
                        <div key={half} className="flex shrink-0" aria-hidden={half === 1}>
                            {[...Array(6)].map((_, i) => (
                                <Segment key={i} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
